import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import { registerServiceWorker } from './utils/serviceWorkerRegistration';
import { syncOfflineData } from './utils/offlineSync';

const container = document.getElementById("root");
const root = createRoot(container);

// Register service worker for PWA
if (process.env.NODE_ENV === 'production') {
  registerServiceWorker();
}

// Sync offline data when app loads and connection is restored
window.addEventListener('load', () => {
  if (navigator.onLine) {
    // Attempt to sync any pending offline operations
    const userId = localStorage.getItem('userId');
    if (userId) {
      syncOfflineData(userId)?.catch(console.error);
    }
  }
});

root.render(<App />);
